import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { Item } from 'typings'
import { Tag } from './Tag'
import { messages } from './messages'
import styles from './styles.css'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  item: Item
}

/**
 * This component is used to render an item inside a tag. If the item has a long name, it will be wrapped and finished with the id.
 * Ex: Item with long... (1)
 */
export function TagItem(props: Props) {
  const { children, item, ...rest } = props
  const { $t } = useIntl()
  const { id, name } = item

  return (
    <Tooltip text={$t(messages.item, { name, id })}>
      <Tag {...rest} className={styles.tagItem}>
        <FormattedMessage
          {...messages.item}
          values={{
            ...item,
            name: <p>{name}</p>,
          }}
        />
      </Tag>
    </Tooltip>
  )
}
